import { makeObservable, observable } from 'mobx';
import { FormField } from './FormField';

interface FormFields {
    [key: string]: FormField;
}

export class Form {
    @observable public fields: FormField[] = [];

    constructor() {
        makeObservable(this);
    }

    public Form(fields: FormField[] = []) {
        this.fields = fields;
    }

    initFromObject(obj: any): Form {
        const fields = Object.keys(obj).map((x) => {
            let value = obj[x];
            let validators = [];
            if (Array.isArray(value)) {
                validators =
                    value.length > 1 && Array.isArray(value[1])
                        ? value[1]
                        : [value[1]];
                value = value[0];
            }

            return new FormField(x, value, validators);
        });

        this.init(fields);
        return this;
    }

    init(fields: FormField[] = []) {
        this.fields = fields;
        return this;
    }

    setValue(value: any, caseInsensitive: boolean = false) {
        Object.keys(value).forEach((k) => {
            const field = caseInsensitive
                ? this.fieldByNameCaseInsensitive(k)
                : this.fieldByName(k);

            if (field) {
                field.init(value[k]);
            }
        });
    }

    reset() {
        this.fields.forEach((f) => f.reset());
    }
    resetState() {
        this.fields.forEach((f) => f.resetState());
    }

    validateAll(): boolean {
        this.fields.forEach((f) => f.validate(true));

        const invalidField = this.fields.find((f) => f.hasError);
        if (invalidField) {
            invalidField.focus();
        }
        return !this.hasErrors;
    }

    get value(): any {
        return Object.assign(
            {},
            ...this.fields.map((f) => ({ [f.name]: f.value }))
        );
    }
    get fieldsObj(): FormFields {
        return Object.assign({}, ...this.fields.map((f) => ({ [f.name]: f })));
    }

    get hasErrors(): boolean {
        return this.fields.some((f) => f.hasError);
    }
    get hasChanges(): boolean {
        return this.fields.some((f) => f.isChanged);
    }

    fieldByName(name: string): FormField | undefined {
        return this.fields.find((f) => f.name === name);
    }
    fieldByNameCaseInsensitive(name: string): FormField | undefined {
        return this.fields.find(
            (f) => f.name.toLowerCase() === name.toLowerCase()
        );
    }
}
